import classnames from "classnames";
import DOMPurify from "dompurify";
import { ProductLogo, TypographyComponent } from "@gx1/gx-npm-ui";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { InitUserTeam, NotificationDiscussionSource } from "../../../../app.constants";
import { UserDiscussionNotification } from "../../../../app.types";
import { formatNotificationDate, getDiscussionTitle, getUserTitle } from "../../notifications.lib";
import { NotificationDiscussionAvatarComponent } from "./notification-discussion-avatar/notification-discussion-avatar.component";
import styles from "./notification-row-discussion.styles.module.scss";

type NotificationRowProps = { notification: UserDiscussionNotification; };
export const NotificationRowDiscussionComponent = ({ notification }: NotificationRowProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.root}>
      <NotificationDiscussionAvatarComponent notification={notification} />
      <div className={styles.contentContainer}>
        <div className={styles.titleRowContainer}>
          <TypographyComponent isMasked={true} rootClassName={styles.titleText} styling="p5" boldness="medium" color="carbon">
            {getUserTitle(notification)}
          </TypographyComponent>
          <div className={styles.timestampContainer}>
            <TypographyComponent styling="p5" color="coal">
              {formatNotificationDate(notification.timestamp)}
            </TypographyComponent>
            <div className={classnames(styles.unreadBadge, !notification.isRead && styles.colorBadge)} />
          </div>
        </div>
        <div className={styles.contentRowContainer}>
          <TypographyComponent isMasked={true} rootClassName={styles.contentText} styling="p4" boldness="medium" color="carbon">
            {getDiscussionTitle(notification)}
          </TypographyComponent>
          {notification.discussionCommentCount === 1 && (
            <TypographyComponent color="iron" isMasked={true} rootClassName={styles.commentText} styling="p4">
              <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notification.discussionComment, { ALLOWED_TAGS: ["strong"] }) }} />
            </TypographyComponent>
          )}
          <span className={styles.footerContainer}>
            {notification.initUserTeam === InitUserTeam.SURVEY_RECIPIENT && notification.discussionCommentUserTeam === InitUserTeam.EVALUATOR && (
              <TypographyComponent rootClassName={styles.initTitleText} element="span" styling="p5" color="coal">
                {notification.surveyCompanyName}
              </TypographyComponent>
            )}
            {notification.initUserTeam !== InitUserTeam.SURVEY_RECIPIENT && (
              <Fragment>
                <TypographyComponent color="coal" element="span" rootClassName={styles.initTitleText} styling="p5">
                  {notification.initTitle || t("Untitled evaluation")}
                </TypographyComponent>
                <TypographyComponent element="span" styling="p5" color="stone">
                  {" I "}
                </TypographyComponent>
                <div className={styles.discussionSourceContainer}>
                  {notification.discussionSource === NotificationDiscussionSource.QUESTIONNAIRE_CROSS_TEAM &&
                    <ProductLogo
                      imageHeight="16px"
                      imageWidth="16px"
                      logo={notification.initProductImageLoc}
                      rootClassName={styles.productLogo}
                    />
                  }
                  <TypographyComponent element="span" styling="p5" color="coal">
                    {
                      {
                        [NotificationDiscussionSource.QUESTIONNAIRE]: t("Questionnaire"),
                        [NotificationDiscussionSource.SCORECARD]: t("Scorecard"),
                        [NotificationDiscussionSource.REQUIREMENT]: t("Requirements"),
                        [NotificationDiscussionSource.QUESTIONNAIRE_CROSS_TEAM]: t("Questionnaire"),
                      }[notification.discussionSource]
                    }
                  </TypographyComponent>
                </div>
              </Fragment>
            )}
          </span>
        </div>
      </div>
    </div>
  );
};
